///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";

import { getUser } from "../api/user";
import { httpResponseStatus, userRole } from "../helpers/types";

export const initialState = {
  isFailure: false,
  isFetching: false,
  user: {
    division: null,
    role: null,
    userId: null,
    userRoleForManagementUser: null
  }
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    requestUser: state => {
      state.isFetching = true;
      state.isFailure = false;
    },
    receiveUserSuccess: (state, { payload }) => {
      state.user = payload;
      state.isFetching = false;
      state.isFailure = false;
    },
    receiveUserFailure: state => {
      state.isFetching = false;
      state.isFailure = true;
    },
    setUserRoleForManagementUser: (state, { payload }) => {
      state.user.userRoleForManagementUser = payload;
    }
  }
});

export const {
  requestUser,
  receiveUserSuccess,
  receiveUserFailure,
  setUserRoleForManagementUser
} = userSlice.actions;

export const userReducer = userSlice.reducer;

export const fetchUser = callback => dispatch => {
  dispatch(requestUser());
  getUser()
    .then(({ data }) => {
      callback && callback(data);
      dispatch(
        receiveUserSuccess({
          ...data,
          role:
            data.userRole === userRole.salesManager ||
            data.userRole === userRole.operations
              ? userRole.salesRep
              : data.userRole,
          userRole: undefined,
          userRoleForManagementUser:
            data.userRole === userRole.management
              ? userRole.tlPricingAnalyst
              : null
        })
      );
    })
    .catch(({ response }) => {
      if (response?.status === httpResponseStatus.forbidden) {
        dispatch(receiveUserSuccess({ role: 0 }));
      } else {
        dispatch(receiveUserFailure(null));
      }
    });
};
